import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { IpcMainEvent } from '@mona/events';
import { MonaRpcService } from './rpc.abstract.service';

/**
 * Overrides
 */
@Injectable({ providedIn: 'root' })
export class MonaRpcBrowserService extends MonaRpcService {
    /**
     * Communicate asynchronously from a renderer process to the main process.
     */
    protected readonly ipcRenderer: any;

    /**
     * Possible values: 'aix', 'darwin', 'freebsd', 'linux', 'openbsd', 'sunos', and 'win32'
     */
    readonly platform: NodeJS.Platform;

    /**
     * INFO: add comment
     *
     * @param window
     */
    constructor(@Inject(WINDOW) protected window: Window) {
        super(window);
        this.platform = 'aix';
        this.ipcRenderer = {};
    }

    /**
     * INFO: add comment
     *
     * @param event
     * @param payload
     */
    invoke<T>(event: IpcMainEvent, payload?: any): Promise<any> {
        switch (event) {
            case IpcMainEvent.GET_JWT_TOKEN:
                return Promise.resolve('mock-token');
            case IpcMainEvent.GET_MAC_ADDRESS:
                return Promise.resolve(this.window.navigator.userAgent.replace(/\s/g, '_'));
            case IpcMainEvent.GET_KEYS:
                return Promise.resolve({
                    version: 1,
                    sshKey: {
                        privateKey: 'string',
                        publicKey: 'string',
                    },
                    telemedicineSshKey: {
                        privateKey: 'string',
                        publicKey: 'string',
                    },
                });
            default:
                return Promise.resolve(null);
        }
    }
}
